import { Injectable } from '@angular/core';
import { Constant } from '../shared/constants';
import { Observable, shareReplay } from 'rxjs';
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import * as fromSmryModels from '../models/supervision-model';
import { Utils } from '../shared/utils';
import * as fromModels from '../models/common-model';
import { SKIP_GLOBAL_LOADER } from '../shared/loader/loaderInterceptor';

@Injectable({
  providedIn: 'root'
})
export class SupervisionService {
  private colorSelection$: Observable<fromSmryModels.ColorSelection[]> | null = null;
  private readonly skipGlobalLoaderContext = new HttpContext().set(SKIP_GLOBAL_LOADER, true);
  
  constructor(private _httpClient: HttpClient) { }

   getSupervisionSmry(_in: any): Observable<HttpResponse<fromSmryModels.SupervisionSmryResponse>> {
    console.log(Constant.uri.getSupervisionSmry);
    
    return this._httpClient.post<fromSmryModels.SupervisionSmryResponse>(Constant.uri.getSupervisionSmry, _in, { ...Utils.getHttpOptions(), observe: 'response' });
  }  

   getSupervisionData(searchCriteria: fromModels.ISearchCriteriaRequest): Observable<fromModels.searchResponse> {
    //return of(_data).delay(2000);  
    return this._httpClient.post<fromModels.searchResponse>(Constant.uri.supervisionActs, searchCriteria, Utils.getHttpOptions());
  }
    getSupervisionItems(request: fromSmryModels.SupervisionReviewRequest): Observable<fromSmryModels.SupervisionReviewReportItems[]> {
    return this._httpClient.post<fromSmryModels.SupervisionReviewReportItems[]>(
      Constant.uri.getSupervisionItems,
      request,
      { ...Utils.getHttpOptions(), context: this.skipGlobalLoaderContext }
    );
  }

  saveSupervisionResponse(supervisionResponse: fromSmryModels.SupervisionReviewReportItems): Observable<fromSmryModels.CreateSupervisionItemResponse> {
    return this._httpClient.post<fromSmryModels.CreateSupervisionItemResponse>(Constant.uri.saveSupervisionReponse, supervisionResponse, Utils.getHttpOptions());
  }

  upload(content: File | null): Observable<any> {
    const formData: FormData = new FormData();
    if (content) {
      formData.append('infile', content, content.name);
    }
    //const _uri = "https://localhost:44366/api/document/uploadfile" + "?folder=supervision"   ;
    const _uri = Constant.uri.uploadFile + "?folder=supervision";
    return this._httpClient.post<any>(_uri, formData, Utils.getHttpOptionsformdata());
  }

  getRefSupervisionQuestionnaire(reportType: string): Observable<fromSmryModels.SupervisionQuestionnaire[]> {
    const _uri = Constant.uri.getRefSupervisionQuestionnaire + '?reportType=' + encodeURIComponent(reportType);
    return this._httpClient.get<fromSmryModels.SupervisionQuestionnaire[]>(
      _uri,
      { ...Utils.getHttpOptions(), context: this.skipGlobalLoaderContext }
    );
  }

  downloadfile(docId: string): Observable<Blob> {
    let _options = {
      headers: new HttpHeaders({
        responseType: 'blob'
      }),
      responseType: 'blob'
    } as any;
    //const _uri = "https://localhost:44366/api/document/DownloadFile" + "?folder=supervision&fname=" + docId;
    const _uri = Constant.uri.downloadFile + "?folder=supervision&fname=" + docId;
    return this._httpClient.get(_uri, { responseType: 'blob' })
  }

  getColorSelection(): Observable<fromSmryModels.ColorSelection[]> {
    if (!this.colorSelection$) {
      this.colorSelection$ = this._httpClient
        .get<fromSmryModels.ColorSelection[]>(Constant.uri.getColorSelection, Utils.getHttpOptions())
        .pipe(shareReplay(1));
    }
    return this.colorSelection$;
  }
}
